module.exports = __webpack_public_path__ + "static/media/XingLiang.8068a046.jpg";